'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var Box = _interopDefault(require('@material-ui/core/Box'));

var TabPanel = function (props) {
    var children = props.children, value = props.value, index = props.index;
    return (React__default.createElement("div", { role: 'tabpanel', hidden: value !== index, id: "tabpanel-" + index, "aria-labelledby": "tab-" + index, style: { width: '100%', overflow: 'auto' } }, value === index && React__default.createElement(Box, { style: { width: '100%', boxSizing: 'border-box' } }, children)));
};

module.exports = TabPanel;
